<template>

<h1>6</h1>

</template>

<script>
export default {
  name: "Button6",


  data() {
    return    {


    }
  },

  methods : {

  }
}
</script>

<style scoped>



</style>
